import React, { useEffect, useState } from 'react';
import { playChestOpen } from '../hooks/useSound';
 

export function TreasureChestAnimation({ type, onDone }) {
  const [visible, setVisible] = useState(true);
  const [open, setOpen] = useState(false);
  const [particles, setParticles] = useState([]);

useEffect(() => {
    playChestOpen(type);
    const t = setTimeout(onDone, 2000);
    return () => clearTimeout(t);
  }, []); // ← nur einmal beim Mou

  useEffect(() => {
    const openTimer = setTimeout(() => {
      setOpen(true);
      generateParticles(); // Partikel erzeugen beim Öffnen
    }, 500);

    const hideTimer = setTimeout(() => {
      setVisible(false);
      if (onDone) onDone();
    }, 4000);

    return () => {
      clearTimeout(openTimer);
      clearTimeout(hideTimer);
    };
  }, [onDone]);
 
  if (!visible) return null;

  const images = {
    bronze: 'https://app.pfandpirat.com/app/assets/icons/chest-bronze.png',
    silver: 'https://app.pfandpirat.com/app/assets/icons/chest-silver.png',
    gold: 'https://app.pfandpirat.com/app/assets/icons/chest-gold.png',
    diamond: 'https://app.pfandpirat.com/app/assets/icons/chest-diamond.png',
  };

  const particleColors = {
    bronze: '#cd7f32',
    silver: '#e0e0e0',
    gold: '#ffd700',
    diamond: '#b9f2ff'
  };

  const generateParticles = () => {
    const newParticles = Array.from({ length: 25 }).map(() => ({
      id: Math.random().toString(36).substr(2, 9),
      x: Math.random() * 200 - 100,
      y: Math.random() * 200 - 150,
      size: Math.random() * 8 + 4,
      delay: Math.random() * 0.5
    }));
    setParticles(newParticles);
  };

  return (
    <div style={{
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      zIndex: 9999,
      pointerEvents: 'none'
    }}>
      <div
        className={`treasure-chest ${open ? 'open' : 'pop'}`}
        style={{
          width: '200px',
          height: '200px',
          backgroundImage: `url(${images[type]})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center'
        }}
      />

      {/* Partikel */}
      {particles.map(p => (
        <React.Fragment key={p.id}>
          <div style={{
            position: 'absolute',
            top: '100px',
            left: '100px',
            width: `${p.size}px`,
            height: `${p.size}px`,
            backgroundColor: particleColors[type],
            borderRadius: '50%',
            opacity: 0,
            animation: `particle-move-${p.id} 1s ease-out ${p.delay}s forwards`
          }} />
          <style>{`
            @keyframes particle-move-${p.id} {
              0% { transform: translate(0, 0); opacity: 1; }
              100% { transform: translate(${p.x}px, ${p.y}px); opacity: 0; }
            }
          `}</style>
        </React.Fragment>
      ))}

      <style>{`
        .treasure-chest.pop {
          animation: chest-pop 0.5s ease-out;
        }

        .treasure-chest.open {
          animation: chest-open 1.5s ease-out, sparkle 2s ease-in-out infinite;
        }

        @keyframes chest-pop {
          0% { transform: scale(0); opacity: 0; }
          50% { transform: scale(1.3); opacity: 1; }
          100% { transform: scale(1); opacity: 1; }
        }

        @keyframes chest-open {
          0% { transform: scale(1) rotateX(0deg); }
          20% { transform: scale(1.1) rotateX(-20deg); }
          50% { transform: scale(1.2) rotateX(-40deg); }
          70% { transform: scale(1.1) rotateX(-30deg); }
          100% { transform: scale(1) rotateX(-20deg); }
        }

        @keyframes sparkle {
          0%, 100% { filter: brightness(1); }
          50% { filter: brightness(1.5); }
        }
      `}</style>
    </div>
  );
}
 